import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment';
import 'moment-timezone';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        menu_toggle: false,
        api: 'http://localhost:5643/',
        user_id: localStorage.getItem('v2_user_id'),
        error_occured: false,
        store_id: 0,
        stores_data: {},
        services_data: {},
        bookings_data: {},
        bookings_data_v2: {},
        customer_data: {},
        booking_image_url_data: {},
        booking_history_data: {},
        staff_wise_bookings: {},
        selected_date: new Date(),
        store_staff_ids: {},
        store_service_ids: {},
        book_id: [],
        services_by_staff: {},
        customer_reports: {},
        revenue_reports: {},
        top_five_customers_reports: [],
        top_five_stylists_reports: [],
        book_status: 0,
        booked_popup: false,
        arrived_popup: false,
        completed_popup: false,
        noshow_popup: false,
        cancel_popup: false,
        latecancel_popup: false,
        loader_popup: false,
        timezone: "Australia/Brisbane",
        // customer data
        products_not_available: false,
        store_categories: {},
        mobile_view: false,
        cust_bookings_data: {},
        cust_store_data: {},
        cust_services_data: {},
        customer_login_data: {},
        temp_start_date: moment(new Date(), 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD"),
        available_stylists: {},
        store_url_name: localStorage.getItem('vue-session-key') ? (JSON.parse(localStorage.getItem('vue-session-key')).store_url_name) : '',
        brisbane_today_date: moment().tz('Australia/Brisbane').format("YYYY-MM-DD"),
        brisbane_today_time: moment().tz('Australia/Brisbane').format("HH:mm:ss"),
        total_services_in_cart: '',
        total_products_in_cart: 0,
        regx: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        slots_available_details: [],
        save_service_Bookings_details: {},
        paymentdetails_data: {},
        booking_details_each_customer_data: {},
        publish_key: 'pk_test_nuLwydB7WMD5MFgHyahlcTZL',
        product_images: [],
        product_image_url_data: [],
        upcoming_bookingdetails_data: {},
        block_customer_data: {},
        cust_login_data: {},
        cust_notes: {},
        selected_products: [],
        products_list: [],
        square_payments: {}
    },
    actions: {



        getStoreByOwnerId({
            commit
        }, [api, owner_id]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `stores/user_stores`, {
                    "user_id": owner_id,
                }).then(response => {
                    commit('ownerStore', response.data.result);
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        getStaffByStoreId({
            commit
        }, [api, store_id]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `staff/get_staff_by_store_id`, {
                    "store_id": store_id,
                    "active_staff": 1
                }).then(response => {
                    commit('storeStaff', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        getServicesByStaffID({
            commit
        }, [api, store_id, staff_id]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `services/get_services_by_staff`, {
                    "store_id": store_id,
                    "staff_id": staff_id
                }).then(response => {
                    commit('services_by_staff', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },


        getServiceByStoreId({
            commit
        }, [api, store_id]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `services/get_services_by_store`, {
                    "store_id": store_id
                }).then(response => {
                    commit('storeService', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        staffwise_bookings({
            commit
        }, [api, calendar_data]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `booking/staffwise`, calendar_data).then(response => {
                    commit('staffBookings', response.data);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        get_booking_details({
            commit
        }, [url, bookId, multi_bookId]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `get_booking_details`, {
                    services: {
                        book_id: bookId,
                        multi_service_book_id: multi_bookId
                    }
                }).then(response => {
                    commit('book_details', response.data.result)
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        get_booking_and_amount_details({
            commit
        }, [url, bookId, multi_bookId]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `transactions/get_bookings_payment_amount`, {
                    book_id: bookId,
                    multi_book_id: multi_bookId
                }).then(response => {
                    commit('book_and_amount_details', response.data.result)
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        get_booking_and_amount_details_v2({
            commit
        }, [url, bookId, multi_bookId]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `transactions/get_bookings_payment_amount_v2`, {
                    book_id: bookId,
                    multi_book_id: multi_bookId
                }).then(response => {

                    commit('book_and_amount_details_v2', response.data.result)
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        async get_customer_details({
            commit
        }, [url, [cust_id, ownerid]]) {
            await axios.post(url + `get_details_of_customer`, {
                cust_id: cust_id,
                owner_id: ownerid
            }).then(response => {
                var customer_details = response.data.result
                if (!customer_details.customer_details[0].cust_picture || (customer_details.customer_details[0].cust_picture == 'null')) customer_details.customer_details[0].cust_picture = '';
                commit('cust_details', customer_details)
            })
        },

        async get_customer_images({
            commit
        }, [url, [user_id, booking_id, multi_bookId]]) {
            await axios.post(url + `get_customer_images`, {
                user_id: user_id,
                booking_id: booking_id,
                multi_service_book_id: multi_bookId
            }).then(response => {
                commit('customer_images', response.data.result)
            })
        },

        async get_product_details({
            commit
        }, [url, [product_id]]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `v2/products/get_product_details_v2`, {
                    "product_id": product_id
                }).then(response => {
                    commit('product_images', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        async get_booking_log({
            commit
        }, [url, bookId, multi_bookId]) {
            await axios.post(url + `booking_log`, {
                services: {
                    book_id: bookId,
                    multi_service_book_id: multi_bookId
                }
            }).then(response => {
                commit('booking_history', response.data.result)
            })
        },

        upload_image({
            commit
        }, [url, img_obj, user_id, booking_id, created_by, update_flag]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `images`, {
                    "image_details": img_obj,
                    "user_id": user_id,
                    "booking_id": booking_id,
                    "created_by": created_by,
                    "update_flag": update_flag
                }).then(response => {
                    commit('upload_image', response.data)
                    resolve(response.data)
                }, error => {
                    commit('upload_image', error)
                    reject(error)
                })
            })
        },

        upload_product_image({
            commit
        }, [url, store_id, product_id, img_obj, created_by, update_flag]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `v2/products/save_product_images_v2`, {
                    "store_id": store_id,
                    "product_id": product_id,
                    "image_details": img_obj,
                    "created_by": created_by,
                    "update_flag": update_flag
                }).then(response => {
                    commit('upload_product_image', response.data)
                    resolve(response.data)
                }, error => {
                    commit('upload_product_image', error)
                    reject(error)
                })
            })
        },

        async add_new_break({ commit }, [url, store_id, user_id, book_start_date, book_end_date, book_start_time, book_end_time, book_duration, book_staff_note, book_created_by, booked_through, booking_type]) {
            return await new Promise((resolve, reject) => {
                axios.post(url + `booking/insert`, {
                    "store_id": store_id,
                    "user_id": user_id,
                    "book_start_date": book_start_date,
                    "book_end_date": book_end_date,
                    "book_start_time": book_start_time,
                    "book_end_time": book_end_time,
                    "book_duration": book_duration,
                    "book_staff_note": book_staff_note,
                    "book_created_by": book_created_by,
                    "booked_through": booked_through,
                    "booking_type": booking_type
                }).then(response => {
                    commit('add_new_break', response.data)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        async edit_break({ commit }, [url, book_id, store_id, user_id, book_start_date, book_end_date, book_start_time, book_end_time, book_duration, book_staff_note, book_updated_by, updated_through, booking_type]) {
            return await new Promise((resolve, reject) => {
                axios.post(url + `booking/insert`, {
                    "book_id": book_id,
                    "store_id": store_id,
                    "user_id": user_id,
                    "book_start_date": book_start_date,
                    "book_end_date": book_end_date,
                    "book_start_time": book_start_time,
                    "book_end_time": book_end_time,
                    "book_duration": book_duration,
                    "book_staff_note": book_staff_note,
                    "book_updated_by": book_updated_by,
                    "updated_through": updated_through,
                    "booking_type": booking_type
                }).then(response => {
                    commit('edit_break', response.data)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        async delete_break({ commit }, [url, book_id, booking_type]) {
            return await new Promise((resolve, reject) => {
                axios.post(url + `booking/insert`, {
                    "book_id": book_id,
                    "booking_type": booking_type
                }).then(response => {
                    commit('delete_break', response.data)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        async edit_staff_hrs({
            commit
        }, [url, store_id, staff_id, exception_date, start_time, end_time, login_user_id, reason, working_status_indicator]) {
            return await new Promise((resolve, reject) => {
                axios.post(url + `staff/add_staff_exceptions`, {
                    "store_id": store_id,
                    "staff_id": staff_id,
                    "exception_date": exception_date,
                    "start_time": start_time,
                    "end_time": end_time,
                    "login_user_id": login_user_id,
                    "reason": reason,
                    "working_status_indicator": working_status_indicator
                }).then(response => {
                    commit('edit_staff_hrs', response.data)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        async update_customer_notes({
            commit
        }, [url, cust_id, owner_id, cust_notes, cust_updated_by]) {
            return await new Promise((resolve, reject) => {
                axios.post(url + 'v2/customer/update_cust_notes_v2', {
                    "owner_cust_id": cust_id,
                    'owner_id': owner_id,
                    "cust_notes": cust_notes,
                    'cust_updated_by': cust_updated_by
                }).then(response => {
                    commit('customer_notes', response.data)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        get_new_and_returning_customers({
            commit
        }, [url, store_date_data]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `servicereport/get_new_and_returning_customers`, store_date_data).then(response => {
                    commit('cust_report', response.data.result)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        get_revenue_report({
            commit
        }, [url, store_date_data]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `servicereport/get_revenue_of_salon`, store_date_data).then(response => {
                    commit('revenue_report', response.data.result)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        top_five_customers_report({
            commit
        }, [url, store_date_data]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `servicereport/top_five_customers`, store_date_data).then(response => {
                    commit('top_five_customers', response.data.result)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        top_five_stylists_report({
            commit
        }, [url, store_date_data]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `servicereport/top_five_stylists`, store_date_data).then(response => {
                    commit('top_five_stylists', response.data.result)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        top_five_services_report({
            commit
        }, [url, store_date_data]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `servicereport/top_five_services`, store_date_data).then(response => {
                    commit('top_five_services', response.data.result)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        top_five_products_report({
            commit
        }, [url, store_date_data]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `servicereport/top_five_products`, store_date_data).then(response => {
                    commit('top_five_products', response.data.result)
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },


        // customer
        squarePayment({
            commit
        }, [api, square_payment_object]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/transactions/square_payment`,
                    square_payment_object
                ).then(response => {
                    commit('set_square_payments', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        getStoreCategories({
            commit
        }, [api, store_id]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `services/get_services_list_by_store`, {
                    "store_id": store_id,
                }).then(response => {
                    commit('store_categories', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        getServiceAvaibleStylists({
            commit
        }, [api, store_id, serv_id, start_date, end_date]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/staff/get_available_staff_slots_v2`, {
                    "store_id": store_id,
                    "serv_id": serv_id,
                    "start_date": start_date,
                    "end_date": end_date
                }).then(response => {
                    commit('available_stylists', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    if (!error.response) {
                        commit('error_var', true);
                    }
                    reject(error)
                })
            })
        },

        getCustomerBookings({
            commit
        }, [url, bookings]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `v2/booking/get_cust_booking_details_v2`, { bookings: bookings }).then(response => {
                    commit('customer_booking_details', response.data.result)
                    resolve(response.data.result)
                }, error => {
                    if (!error.response) {
                        commit('error_var', true);
                    }
                    reject(error)
                })
            })
        },

        getStoreDetails({
            commit
        }, [api, store_url_name]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/stores/get_store_details_v2`, {
                    "store_url_name": store_url_name
                }).then(response => {
                    commit('storeDetails', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    if (!error.response) {
                        commit('error_var', true);
                    }
                    reject(error)
                })
            })
        },

        getServicesByCategories({
            commit
        }, [api, store_url_name]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/services/get_services_list_by_url_v2`, {
                    "store_url_name": store_url_name
                }).then(response => {
                    commit('service_Bookings', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    if (!error.response) {
                        commit('error_var', true);
                    }
                    reject(error)
                })
            })
        },
        slotsAvailabilityCheck({
            commit
        }, [api, slots, products, reschedule = 0]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/staff/check_selected_slot_availability_v2`, {
                    "slots": slots,
                    "products": products,
                    "reschedule": reschedule
                }).then(response => {
                    commit('slots_availability', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    if (!error.response) {
                        commit('error_var', true);
                    }
                    reject(error)
                })
            })
        },

        saveBooking({
            commit
        }, [api, bookings_obj]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/booking/add_bookings_v2`,
                    bookings_obj
                ).then(response => {
                    commit('save_service_Bookings', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        getPaymentDetails({
            commit
        }, [api, bookingdetails]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/transactions/get_payment_details_cust_bookings_v2`, {
                    "bookings": bookingdetails
                }).then(response => {
                    commit('cust_payment_details', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    if (!error.response) {
                        commit('error_var', true);
                    }
                    reject(error)
                })
            })
        },

        getBookingDetailsEachCustomer({
            commit
        }, [api, type, book_id, multi_bookId]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/booking/get_cust_each_booking_details_v2`, {
                    "book_id": book_id,
                    "multi_service_book_id": multi_bookId,
                    "type": type
                }).then(response => {
                    commit('booking_details_each_customer', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },


        getUpComingBookingDetails({
            commit
        }, [api, cust_email, limit]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/customer/booking_details`, {
                    "cust_email": cust_email,
                    "start": limit
                }).then(response => {
                    commit('upcoming_bookingdetails', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error)
                })
            })
        },

        checkBlockCustomer({
            commit
        }, [api, cust_email, store_id]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/customer/check_blocked_cust_v2`, {
                    "cust_email": cust_email,
                    "store_id": store_id
                }).then(response => {
                    commit('block_Customer', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    if (!error.response) {
                        commit('error_var', true);
                    }
                    reject(error)
                })
            })
        },

        custLogin({
            commit
        }, [api, cust_email, ciphertext]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/login/cust_login_v2`, {
                    "cust_user_name": cust_email,
                    "password": ciphertext,
                }).then(response => {
                    commit('customer_login', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    reject(error.response.data.errors)
                })
            })
        },

        getProducts({
            commit
        }, [api, store_id, cust_side]) {
            return new Promise((resolve, reject) => {
                axios.post(api + `v2/products/get_products_list_v2`, {
                    "store_id": store_id,
                    "customer_side": cust_side,
                }).then(response => {
                    commit('store_products_list', response.data.result);
                    resolve(response.data.result)
                }, error => {
                    if (!error.response) {
                        commit('error_var', true);
                    }
                    reject(error)
                })
            })
        },
        send_form_url({
            commit
        }, [url, cust_email, form_url]) {
            return new Promise((resolve, reject) => {
                axios.post(url + `v2/booking/send_form_v2`, {
                    "form_url": form_url,
                    "cust_email": cust_email
                }).then(response => {
                    resolve(response.data)
                }, error => {
                    commit('upload_product_image', error)
                    reject(error)
                })
            })
        },
    },
    mutations: {

        error_var(state, error_boolean) {
            state.error_occured = error_boolean;
            state.loader_popup = false;
        },

        storeUrlName(state, store_url_name) {
            state.store_url_name = store_url_name;
        },

        setUrl(state, api) {
            state.api = api;
        },

        menu_toggle(state) {
            state.menu_toggle = !state.menu_toggle;
        },

        staffBookings(state, staffbookings) {
            state.staff_wise_bookings = staffbookings;
        },

        book_details(state, services) {
            state.services_data = services;
        },

        book_and_amount_details(state, book_and_amt_data) {
            state.bookings_data = book_and_amt_data;
        },


        book_and_amount_details_v2(state, book_and_amt_data) {
            state.bookings_data_v2 = book_and_amt_data;
        },

        cust_details(state, customers) {
            state.customer_data = customers;
        },

        customer_images(state, booking_images) {
            state.booking_image_url_data = booking_images;
        },

        product_images(state, product_images) {
            state.product_image_url_data = product_images;
        },

        booking_history(state, book_history) {
            state.booking_history_data = book_history;
        },

        upload_image(state, image_uploaded) {
            state.upload_image = image_uploaded;
        },
        upload_product_image(state, image_uploaded) {
            state.upload_product_image = image_uploaded;
        },

        ownerStore(state, stores) {
            state.stores_data = stores;
            state.store_id = stores[0].store_id;
        },

        storeStaff(state, staff) {
            state.store_staff_ids = staff;
        },

        services_by_staff(state, services) {
            state.services_by_staff = services
        },

        storeService(state, service) {
            state.store_service_ids = service;
        },

        service_status_update(state, [bookId, multi_bookId, status, login_id, updated_by, edit_flag]) {
            return new Promise((resolve, reject) => {
                axios.post(state.api + `booking/book_service_status_update`, {
                    book_id: bookId,
                    multi_service_book_id: multi_bookId,
                    book_status: status,
                    book_updated_by: login_id,
                    updated_through: updated_by,
                    edit_flag: edit_flag
                }).then(response => {
                    resolve(response.data)
                }, error => {
                    reject(error)
                })
            })
        },

        working_hours_update(state, [store_id, date, staff_id, work_start_time, work_end_time]) {
            axios.post(state.api + `staff/add_staff_exceptions`, {
                store_id: store_id,
                staff_id: staff_id,
                exception_date: date,
                start_time: work_start_time,
                end_time: work_end_time,
                login_user_id: '5',
                reason: '',
                working_status_indicator: '1'
            }).then(response => {
                return response.data
            })
        },

        add_new_break(state, add_new_break) {
            state.add_new_break = add_new_break;
        },

        edit_break(state, edit_break) {
            state.edit_break = edit_break;
        },

        delete_break(state, delete_break) {
            state.edit_break = delete_break;
        },

        edit_staff_hrs(state, edit_staff_hrs) {
            state.edit_staff_hrs = edit_staff_hrs;
        },

        customer_notes(state, cust_notes) {
            state.cust_notes = cust_notes;
        },

        cust_report(state, customer_report) {
            state.customer_reports = customer_report;
        },

        revenue_report(state, revenue_report) {
            state.revenue_reports = revenue_report;
        },

        top_five_customers(state, customer_top_report) {
            state.top_five_customers_reports = customer_top_report;
        },

        top_five_stylists(state, stylist_top_report) {
            state.top_five_stylists_reports = stylist_top_report;
        },

        top_five_services(state, services_top_report) {
            state.top_five_services_reports = services_top_report;
        },

        top_five_products(state, products_top_report) {
            state.top_five_products_reports = products_top_report;
        },

        // customer
        set_square_payments(state, payment) {
            state.square_payments = payment
        },

        store_categories(state, store_categories) {
            state.store_categories = store_categories;
        },

        available_stylists(state, available_stylists) {
            state.available_stylists = available_stylists;
        },

        customer_booking_details(state, cust_bookings) {
            state.cust_bookings_data = cust_bookings;
        },

        storeDetails(state, store_data) {
            state.cust_store_data = store_data;
        },

        service_Bookings(state, cust_services) {
            state.cust_services_data = cust_services;
        },

        cust_login_details(state, cust_login_details) {
            state.customer_login_data = cust_login_details;
        },

        slots_availability(state, slots_available) {
            state.slots_available_details = slots_available;
        },

        save_service_Bookings(state, save_service_Bookings) {
            state.save_service_Bookings_details = save_service_Bookings;
        },

        cust_payment_details(state, paymentdetails) {
            state.paymentdetails_data = paymentdetails;
        },

        booking_details_each_customer(state, booking_details_each_customer) {
            state.booking_details_each_customer_data = booking_details_each_customer;
        },

        block_Customer(state, block_customer) {
            state.block_customer_data = block_customer
        },

        customer_login(state, cust_login) {
            state.cust_login_data = cust_login;
        },

        store_products_list(state, products) {
            state.products_list = products;
        },


        async upcoming_bookingdetails(state, upcoming_bookingdetails) {
            await upcoming_bookingdetails.sort((a, b) => {
                let aDate = new Date(a.book_start_date + ' ' + a.book_start_time)
                let bDate = new Date(b.book_start_date + ' ' + b.book_start_time)
                return bDate.getTime() - aDate.getTime()
            });
            state.upcoming_bookingdetails_data = upcoming_bookingdetails;
        },


        responsive_view(state, view_width) {
            if (view_width < 576) {
                state.mobile_view = true;
            } else {
                state.mobile_view = false;
            }
        }

    },
    getters: {
        get_services: state => { return state.services_data },
        get_bookings_and_amount_data: state => { return state.bookings_data },
        get_bookings_and_amount_data_v2: state => { return state.bookings_data_v2 },
        get_customers: state => { return state.customer_data },
        get_booking_images: state => { return state.booking_image_url_data },
        get_booking_history: state => { return state.booking_history_data },
        upload_image: state => { return state.upload_image },
        get_product_images: state => { return state.product_image_url_data },
        upload_product_image: state => { return state.upload_product_image },
        get_products: state => { return state.products_list },
    }

})

export default store;